import { render, staticRenderFns } from "./userReport.vue?vue&type=template&id=36e99e30&scoped=true&"
import script from "./userReport.vue?vue&type=script&lang=js&"
export * from "./userReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e99e30",
  null
  
)

export default component.exports